import actionTypes from "../../actions/index";

const initialState = {
  jobsListings: {},
};

const jobOpenigsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.JOB_LISTING:
      return {
        ...state,
        jobsListings: action.payload,
      };
    case actionTypes.JOB_DETAILS:
      return {
        ...state,
        jobDetails: action.payload,
      };
    default:
      return state;
  }
};

export default jobOpenigsReducer;
